import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { LoginResponse } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface RefreshLoginParams extends DefaultHttpHeaders {}

@Injectable()
export class RefreshLoginService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Refresh login from Comeround
   * Refresh login from Comeround
   * - To refresh token it's used Bearer Atuhorization. RefreshToken will be sent in Authorization header.
   *
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Authentication/refreshLogin
   */
  refreshLogin(params: RefreshLoginParams): Observable<LoginResponse> {
    return this.get<LoginResponse>({
      suffix: '/authentications/refreshLogin',
      headers: params,
      authenticationType: 'jwt',
    });
  }
}
